import Label from "../../../../components/label/label";
import Input from "../../../../components/input/input";
import Button from "../../../../components/button/button";
import { useNotes } from "../../../../hooks/useNotes";
import { useState, useEffect } from "react";

function CuDeNote({ id }) {
    const { fetchNotes, notes, deleteNote, editNote, saveNote } = useNotes();
    const [noteText, setNoteText] = useState('');
    const [createNote, setCreateNote] = useState(false);

    useEffect(() => {
        fetchNotes(id);
    }, [id, fetchNotes]);

    const handleSubmit = (e) => {
        e.preventDefault();
        saveNote(id, noteText);
        setNoteText('');
        setCreateNote(false);
    };

    return (
        <div className="cudeContentContainer">
            <div className="cudeHeadingContainer">
                <h3>Notizen</h3>
            </div>
            {createNote && (
                <form onSubmit={handleSubmit}>
                    <Label labelFor="noteText" labelValue="Notiz:" />
                    <br />
                    <Input
                        borderColor='#15283B'
                        inputType="text"
                        inputId="noteText"
                        inputName="noteText"
                        inputValue={noteText}
                        onChange={(e) => setNoteText(e.target.value)}
                    />
                    <Input
                        borderColor='#15283B'
                        inputType="submit"
                        inputId="submit"
                        inputName="submit"
                        inputValue="Notiz hinzufügen"
                        height='40px'
                    />
                </form>
            )}
            {notes.length === 0 ? (
                <div className="cudeCard">
                    <p>Keine Notizen vorhanden</p>
                </div>
            ) : (
                notes.map((note, index) => (
                    <div key={index} className="cudeCard">
                        <p><strong>Notiz:</strong> {note.note}</p>
                        <button onClick={() => editNote(id, note._id)}>Bearbeiten</button>
                        <button onClick={() => deleteNote(id, note._id)}>Löschen</button>
                    </div>
                ))
            )}
            <Button buttonType='button' buttonValue='Neue Notiz' onClick={() => setCreateNote(!createNote)} />
        </div>
    );
}

export default CuDeNote;